import React, { useState, useEffect } from "react";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { MessageSquare, Mail, CheckCircle } from "react-feather";
import DataTable from "react-data-table-component";
import { Modal, Button, Form, Accordion } from "react-bootstrap";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";

const MyInquireySeller = () => {
  const seller_id = localStorage.getItem("seller_id");
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); 
  const [selectedInquiry, setSelectedInquiry] = useState(null);
  const [modalInput, setModalInput] = useState("");
  const [emailLoading, setEmailLoading] = useState(false); 

  // Fetch Inquiries
  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await axios.get(`${baseurl}FetchCartInquiryForSeller/${seller_id}`);
        setInquiries(response.data.cartItems || []);
      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch inquiries!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false
        });
      } finally {
        setLoading(false);
      }
    };
    if (seller_id) fetchInquiries();
  }, [seller_id]);

  // Open Modal
  const openModal = (type, inquiry) => {
    setModalType(type);
    setSelectedInquiry(inquiry);
    if(type === "remark") setModalInput(inquiry.remark || "");
    else if(type === "status") setModalInput(inquiry.seller_status || "");
    else setModalInput("");
    setShowModal(true);
  };

  // API Calls
  const addRemarkAPI = async (cart_id, remark) => axios.post(`${baseurl}AddRemark`, { cart_id, remark, seller_id });
  const updateStatusAPI = async (cart_id, status) => axios.post(`${baseurl}UpdateSellerStatus`, { cart_id, seller_status: status, seller_id });
  const sendEmailAPI = async (email, message, cart_id) => axios.post(`${baseurl}RespondToCustomer`, { email, response_text: message, cart_id, seller_id });

  // Handle Modal Submit
  const handleModalSubmit = async () => {
    if(!modalInput) {
      Swal.fire({ icon: "warning", title: "Oops!", text: "Please enter a value!", toast: true, position: "top-end", timer: 2500, showConfirmButton: false });
      return;
    }

    try {
      if(modalType === "remark") await addRemarkAPI(selectedInquiry.cart_id, modalInput);
      if(modalType === "status") await updateStatusAPI(selectedInquiry.cart_id, modalInput);
      if(modalType === "email") {
        setEmailLoading(true);
        await sendEmailAPI(selectedInquiry.customer?.user_email, modalInput, selectedInquiry.cart_id);
        setEmailLoading(false);
      }

      Swal.fire({ icon: "success", title: `${modalType === 'remark' ? 'Remark' : modalType === 'status' ? 'Status' : 'Email'} Updated`, toast: true, position: "top-end", timer: 2500, showConfirmButton: false });

      // Refresh table
      const response = await axios.get(`${baseurl}FetchCartInquiryForSeller/${seller_id}`);
      setInquiries(response.data.cartItems || []);

    } catch (error) {
      console.error(error);
      Swal.fire({ icon: "error", title: "Error", text: "Something went wrong!", toast: true, position: "top-end", timer: 3000, showConfirmButton: false });
      setEmailLoading(false);
    }

    setShowModal(false);
  };

  // Table Columns
  const columns = [
    { name: "Image", selector: row => row.image, cell: row => <img src={`${imageUrl}listing/${row.image}`} alt={row.title} width="50" height="50" className="rounded" /> },
    { name: "Title", selector: row => row.title, sortable: true },
    { name: "Customer", selector: row => row.customer, cell: row => (<>{row.customer?.first_name} {row.customer?.last_name} </>), sortable: true },
    { name: "Requested At", selector: row => new Date(row.added_at).toLocaleDateString(), sortable: true },
    { name: "Remark", selector: row => row.remark, cell: row => row.remark || "-", sortable: true },
    { name: "Seller Status", selector: row => row.seller_status, cell: row => row.seller_status || "-", sortable: true },
    { 
      name: "Actions", 
      cell: row => (
        <div className="d-flex flex-wrap gap-1">
          <Button size="sm" variant="outline-primary" onClick={() => openModal("remark", row)}><MessageSquare size={14}/>  </Button>
          <Button size="sm" variant="outline-success" onClick={() => openModal("status", row)}><CheckCircle size={14}/> </Button>
          <Button size="sm" variant="outline-warning" onClick={() => openModal("email", row)}><Mail size={14}/> </Button>
        </div>
      )
    }
  ];

  // Expandable Component for Accordion
  const ExpandedComponent = ({ data }) => (
    <Accordion>
      {data.seller_responses?.length > 0 ? data.seller_responses.map((res, idx) => (
        <Accordion.Item eventKey={idx.toString()} key={idx}>
          <Accordion.Header><span className="acspn">{`Sent at: ${new Date(res.sent_at).toLocaleDateString()}`}</span></Accordion.Header>
          <Accordion.Body>{res.message}</Accordion.Body>
        </Accordion.Item>
      )) : <div className="p-3">No email responses yet.</div>}
    </Accordion>
  );

  return (
    <>
      <SellerNavbar />
      <section className="mb-5">
        <div className="container-fluid">
          <div className="row my-3 g-2 justify-content-center">
            <div className="col-md-2"><SellerSidebar /></div>
            <div className="col-md-10 text-start">
              <h4 className="selh1">All Inquiries</h4>
              <div className="card p-3 mt-3">
                <DataTable 
                  columns={columns} 
                  data={inquiries} 
                  progressPending={loading} 
                  pagination 
                  highlightOnHover 
                  striped 
                  responsive
                  expandableRows
                  expandableRowsComponent={ExpandedComponent}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "remark" && "Add Remark"}
            {modalType === "status" && "Update Status"}
            {modalType === "email" && `Respond to Customer`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              {modalType === "status" ? (
                <Form.Select value={modalInput} onChange={e => setModalInput(e.target.value)}>
                  <option value="">Select status</option>
                  <option value="Closed">Closed</option>
                  <option value="Hold">Hold</option>
                  <option value="Interested">Interested</option>
                </Form.Select>
              ) : (
                <Form.Control as="textarea" rows={3} placeholder={modalType === "remark" ? "Enter your remark" : "Enter your email response"} value={modalInput} onChange={e => setModalInput(e.target.value)} />
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={handleModalSubmit} disabled={emailLoading}>
            {emailLoading ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span> Sending...</> : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MyInquireySeller;
